import reduxConnector from 'root/src/shared/util/reduxConnector'

import projectTitleSelector from 'root/src/client/logic/project/selectors/projectTitleSelector'
import projectDescriptionSelector from 'root/src/client/logic/project/selectors/projectDescriptionSelector'
import pledgeAmountSelector from 'root/src/client/logic/project/selectors/pledgeAmountSelector'
import projectGameImagePortraitSelector from 'root/src/client/logic/project/selectors/projectGameImagePortraitSelector'
import projectAssigneesImagesSelector from 'root/src/client/logic/project/selectors/projectAssigneesImagesSelector'
import projectAssigneesSelector from 'root/src/client/logic/project/selectors/projectAssigneesSelector'
import projectShareUrlSelector from 'root/src/client/logic/project/selectors/projectShareUrlSelector'
import projectGamesSelector from 'root/src/client/logic/project/selectors/projectGamesSelector'
import isAuthenticated from 'root/src/client/logic/auth/selectors/isAuthenticated'
import projectPledgedSelector from 'root/src/client/logic/project/selectors/projectPledgedSelector'
import projectAssigneNameSelector from 'root/src/client/logic/project/selectors/projectAssigneNameSelector'
import projectAssigneeIsLiveSelector from 'root/src/client/logic/project/selectors/projectAssigneeIsLiveSelector'
import projectDeliveriesSelector from 'root/src/client/logic/project/selectors/projectDeliveriesSelector'
import projectAcceptedSelector from 'root/src/client/logic/project/selectors/projectAcceptedSelector'
import listRouteIdSelector from 'root/src/client/logic/project/selectors/listRouteIdSelector'
import goalProgressSelector from 'root/src/client/logic/project/selectors/goalProgressSelector'
import projectUrlSelector from 'root/src/client/logic/project/selectors/projectUrlSelector'
import goalAmountSelector from 'root/src/client/logic/project/selectors/goalAmountSelector'
import timeLeftSelector from 'root/src/client/logic/project/selectors/timeLeftSelector'
import isTwitchPanelDareSelector from 'root/src/client/logic/project/selectors/isTwitchPanelDareSelector'
import payoutInfoItemSelector from 'root/src/client/logic/project/selectors/payoutInfoItemSelector'
import brandProductSelector from 'root/src/client/logic/project/selectors/brandProductSelector'
import isBrandUserSelector from 'root/src/client/logic/static/selectors/isBrandUserSelector'
import myProfileSelector from 'root/src/client/logic/route/selectors/myProfileSelector'
import projectStatusSelector from 'root/src/client/logic/project/selectors/projectStatusSelector'
import claimSponsoredProject from 'root/src/client/logic/project/thunks/claimSponsoredProject'
import isOneOfAssigneesSelector from 'root/src/client/logic/project/selectors/isOneOfAssigneesSelector'
import reportCtaClick from 'root/src/client/logic/project/thunks/reportCtaClick'
import projectIdSelector from 'root/src/client/logic/project/selectors/projectIdSelector'
import pinProject from 'root/src/client/logic/project/thunks/pinProject'
import isPinnedDareSelector from 'root/src/client/logic/project/selectors/isPinnedDareSelector'
import showPinSelector from 'root/src/client/logic/project/selectors/showPinSelector'
import projectCreatorDataSelector
	from 'root/src/client/logic/project/selectors/projectCreatorDataSelector'
import projectRewardForSelector
	from 'root/src/client/logic/project/selectors/projectRewardForSelector'

export default reduxConnector(
	[
		['projectDescription', projectDescriptionSelector],
		['projectTitle', projectTitleSelector],
		['pledgeAmount', pledgeAmountSelector],
		['projectGameImage', projectGameImagePortraitSelector],
		['projectAssigneesImages', projectAssigneesImagesSelector],
		['projectAssigneesName', projectAssigneNameSelector],
		['projectAssigneeIsLive', projectAssigneeIsLiveSelector],
		['projectShareUrl', projectShareUrlSelector],
		['projectGames', projectGamesSelector],
		['projectPledged', projectPledgedSelector],
		['goalProgress', goalProgressSelector],
		['projectAccepted', projectAcceptedSelector],
		['isAuthenticated', isAuthenticated],
		['projectDeliveries', projectDeliveriesSelector],
		['listRouteId', listRouteIdSelector],
		['projectUrl', projectUrlSelector],
		['goalAmount', goalAmountSelector],
		['timeLeft', timeLeftSelector],
		['isTwitchPanelDare', isTwitchPanelDareSelector],
		['payoutInfo', payoutInfoItemSelector],
		['brandProduct', brandProductSelector],
		['isBrandUser', isBrandUserSelector],
		['projectAssignees', projectAssigneesSelector],
		['myProfileRoute', myProfileSelector],
		['projectStatus', projectStatusSelector],
		['isOneOfAssignees', isOneOfAssigneesSelector],
		['projectId', projectIdSelector],
		['isPinnedDare', isPinnedDareSelector],
		['showPin', showPinSelector],
		['projectCreatorData', projectCreatorDataSelector],
		['rewardFor', projectRewardForSelector],
	],
	[
		['claimSponsoredProject', claimSponsoredProject],
		['reportCtaClick', reportCtaClick],
		['pinProject', pinProject],
	],
)
